import * as s from "../RecordersStyled";
import { SubscriptionInfo } from "api/interfaces/recorderInterface.interface";
import { COLORS } from "styles/colors";
import { convertMsToDays, substractTimeFromNow } from "utils/timeUtil";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { BILLING_TYPE } from "api/interfaces/planInterface.interface";
import { getSubscriptionTrial } from "utils/AccountUtil";

type Props = {
  subscriptionInfo: SubscriptionInfo;
};

export default function SubscriptionStatus({
  subscriptionInfo,
}: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const { isTrial, trialExpire, channelExpire, covaFreeExpire } =
    subscriptionInfo;

  if (Boolean(channelExpire || covaFreeExpire) && selectedAccount.isEnabled) {
    return <></>;
  }

  if (trialExpire && getSubscriptionTrial({ subscriptionInfo })) {
    return (
      <s.LicenseInfoItem>
        <s.SubscriptionInfoStyled.Value color={COLORS.BUTTONS2}>
          Trial {convertMsToDays(-substractTimeFromNow(trialExpire))} day(s)
        </s.SubscriptionInfoStyled.Value>
      </s.LicenseInfoItem>
    );
  }

  if (
    !selectedAccount.isEnabled ||
    (selectedAccount.billingType !== BILLING_TYPE.USAGE &&
      !channelExpire &&
      !covaFreeExpire)
  ) {
    return (
      <s.LicenseInfoItem>
        <s.SubscriptionInfoStyled.Value color={COLORS.VALIDATERED}>
          {/* {trialExpire && !(-substractTimeFromNow(trialExpire) > 1) && (
            <span className="expire-text">Expired</span>
          )} */}
          No Subscription
        </s.SubscriptionInfoStyled.Value>
      </s.LicenseInfoItem>
    );
  }

  return <></>;
}
